import React, { useState, useEffect } from 'react';
// import { postGolfRateMaster } from '../api/paymentAPI';
import * as helper from '../global/helper';
import swal from 'sweetalert2';
import { getGreenFeeCalendarAll, getGreenFeeMasterByCalenderID, postGreenFeeMaster } from '../api/teeTimeAPI';
import CategoryTable from '../tournament/categoryTable';
import Select from 'react-select';

const rows = [
    { no: 1,  CategoryID: 1, SubCategoryID: 1,Hole: 18, UserType: 'OGR Member', Type: 'Weekday' },
    { no: 2,  CategoryID: 1, SubCategoryID: 1, Hole: 18, UserType: 'OGR Member', Type: 'Weekends' },
    { no: 3,  CategoryID: 1, SubCategoryID: 1, Hole: 9, UserType: 'OGR Member', Type: 'Weekday' },
    { no: 4,  CategoryID: 1, SubCategoryID: 1, Hole: 9, UserType: 'OGR Member', Type: 'Weekends' },
    { no: 5,  CategoryID: 2, SubCategoryID: 5, Hole: 18, UserType: 'Members Guest', Type: 'Weekday' },
    { no: 6,  CategoryID: 2, SubCategoryID: 5, Hole: 18, UserType: 'Members Guest', Type: 'Weekends' },
    { no: 7,  CategoryID: 2, SubCategoryID: 5, Hole: 9, UserType: 'Members Guest', Type: 'Weekday' },
    { no: 8,  CategoryID: 2, SubCategoryID: 5, Hole: 9, UserType: 'Members Guest', Type: 'Weekends' },
    { no: 9,  CategoryID: 2, SubCategoryID: 4, Hole: 18, UserType: 'Room Guest', Type: 'Weekday' },
    { no: 10, CategoryID: 2, SubCategoryID: 4, Hole: 18, UserType: 'Room Guest', Type: 'Weekends' },
    { no: 11, CategoryID: 2, SubCategoryID: 4, Hole: 9, UserType: 'Room Guest', Type: 'Weekday' },
    { no: 12, CategoryID: 2, SubCategoryID: 4, Hole: 9, UserType: 'Room Guest', Type: 'Weekends' },
    { no: 13, CategoryID: 2, SubCategoryID: 3, Hole: 18, UserType: 'Walking Guest', Type: 'Weekday' },
    { no: 14, CategoryID: 2, SubCategoryID: 3, Hole: 18, UserType: 'Walking Guest', Type: 'Weekends' },
    { no: 15, CategoryID: 2, SubCategoryID: 3, Hole: 9, UserType: 'Walking Guest', Type: 'Weekday' },
    { no: 16, CategoryID: 2, SubCategoryID: 3, Hole: 9, UserType: 'Walking Guest', Type: 'Weekends' },
    { no: 17, CategoryID: 1, SubCategoryID: 2, Hole: 18, UserType: 'Residence Owner', Type: 'Weekday' },
    { no: 18, CategoryID: 1, SubCategoryID: 2, Hole: 18, UserType: 'Residence Owner', Type: 'Weekends' },
    { no: 19, CategoryID: 1, SubCategoryID: 2, Hole: 9, UserType: 'Residence Owner', Type: 'Weekday' },
    { no: 20, CategoryID: 1, SubCategoryID: 2, Hole: 9, UserType: 'Residence Owner', Type: 'Weekends' }
];
const GreenFeeMaster = (props) => {
 
    const [allMaster,               setAllMaster]            = useState([]);
    const [calenderID,              setCalenderID]           = useState(null);
    const [greenMasterList,         setGreenMasterList]      = useState([]);

    useEffect(() => {
        props.title("GreenFee Master", "green-fee-master");
        fetchGreenFeeCalendar();
    }, []);

    useEffect(() => {
        if(calenderID != null){
            fetchGreenFeeMasterByCalenderID(calenderID)
        }
    }, [calenderID]);

    const fetchGreenFeeCalendar = async () => {
        try {
            const calendar = await getGreenFeeCalendarAll();
            setAllMaster(calendar); 
        } catch (error) {
            swal.fire({ icon :'error', titleText : error.message });
        }
    }

    const fetchGreenFeeMasterByCalenderID = async (calenderID) => {
        try {
            const master = await getGreenFeeMasterByCalenderID(calenderID);
            
            setGreenMasterList(master); 
        } catch (error) {
            swal.fire({ icon :'error', titleText : error.message });
        }
    }
 
    const initialRateMasterDetails = rows.map(row => ({
        ID: row.ID,
        CalenderID: calenderID,
        CategoryID: row.CategoryID,
        SubCategoryID: row.SubCategoryID,
        UserType: row.UserType,
        Name: '',
        Hole: row.Hole,
        IsWeekend: row.Type == "Weekday" ? "N" : "Y",
        Type: row.Type,
        GreenFee: 0,
        Cart: 0,
        Caddy: 0,
        Tax: 0,
        Total: 0,
        Remark: '',
    }));

    const [rateMasterList, setRateMasterList] = useState(initialRateMasterDetails);

    useEffect(() => {
        if ( greenMasterList.length > 0) {
            setRateMasterList(greenMasterList);
        } else {
            setRateMasterList(initialRateMasterDetails);
        }
    }, [greenMasterList]) 

    const updateRateMaster = (userType, hole, type, field, value) => {
        setRateMasterList((prevDetails) => {
            return prevDetails.map(detail => {
                if (detail.UserType === userType && detail.Hole === hole && detail.Type === type) {
                    const updatedDetail = {
                        ...detail,
                        [field]: value,
                    };

                    const greenFee = parseFloat(updatedDetail.GreenFee) || 0;
                    const cart = parseFloat(updatedDetail.Cart) || 0;
                    const caddy = parseFloat(updatedDetail.Caddy) || 0;

                    const rate = greenFee + cart + caddy;
                    const tax = rate * 0.18;
                    const total = rate + tax;

                    updatedDetail.Tax = tax;
                    updatedDetail.Total = Math.round(total);

                    return updatedDetail;
                }
                return detail;
            });
        });
    };

    const syncHole18WithHole9 = (list) => {
        return list.map((item) => {
            if (item.Hole == 9) {
                const matRecord = list.find(r =>
                    r.UserType === item.UserType &&
                    r.Hole == 18 &&
                    r.Type === item.Type
                );
                if (matRecord) {
                    return {
                        ...item,
                        GreenFee: matRecord.GreenFee,
                        Cart: matRecord.Cart,
                        Caddy: matRecord.Caddy,
                        Tax: matRecord.Tax,
                        Total: matRecord.Total,
                        Remark: matRecord.Remark,
                    };
                }
            }
            return item;
        });
    };

    const handleSave = async () => {
        const btn = $('#btnSave');
        helper.StartProcessing(btn);

        try {
            // const syncedRateMasterList = syncHole18WithHole9(rateMasterList);
            await postGreenFeeMaster(rateMasterList);
            if (rateMasterList[0].ID) {
                swal.fire({
                    toast: true,
                    icon: 'success',
                    titleText: 'Master updated successfully!',
                    position: 'bottom-end',
                    showConfirmButton: false,
                    timer: 3500,
                    onOpen: () => swal.hideLoading()
                });
            } else {
                swal.fire({
                    icon: 'success',
                    titleText: 'Master added successfully!',
                    showConfirmButton: false,
                    timer: 3500,
                    onOpen: () => swal.hideLoading()
                });
            }
            fetchGreenFeeMasterByCalenderID(calenderID);
            helper.StopProcessing(btn);

        } catch (err) {
            helper.StopProcessing(btn);
            swal.fire({
                icon: 'error',
                titleText: 'Error!',
                text: err.message,
                buttonsStyling: false,
                confirmButtonClass: 'btn btn-brand',
            });
            return;
        }
    };

    return (
        <>
            <div className="kt-content kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor padding-b0" id="kt_content" style={{paddingTop: '0px'}}>
                    <div className="kt-container  kt-container--fluid  kt-grid__item kt-grid__item--fluid margin-t20">
                        <div className="kt-portlet kt-portlet--mobile">
                            <div className="kt-portlet__body kt-portlet__body--fit padding-t20 padding-b0">
                                <div id="ControlHolder" className="kt-form kt-form--label-right padding-10 border-bottom-light" role="form">
                                    <div className="row">
                                        <div className="col-sm-3"></div>
                                        <div className="form-group col-sm-2">
                                            <div className="ddlCoursePnl">
                                                <Select
                                                    value={(allMaster && allMaster.length > 0 && calenderID) && {label: allMaster.find(c => c.ID == calenderID).Name, value: calenderID}}
                                                    onChange={(event) => setCalenderID(event.value)}
                                                    name="ddlMaster"
                                                    placeholder="Select Calender Master"
                                                    id="ddlMaster"
                                                    className="ddMaster"
                                                    options={allMaster?.length > 0 && allMaster?.map(c => ({
                                                        label: c.Name,
                                                        value: c.ID
                                                    }))}
                                                />                                        
                                            </div>
                                        </div> 
                                    </div>
                                </div>
                                <div>
                                    {calenderID != null &&(
                                        <div id="accordionExample4">
                                            {/* <div id={`collapse-${ID}`} className={`collapseshow`} aria-labelledby={`menuHeading-${ID}`} data-parent="#accordionExample4"> */}
                                                <div className="card-body">
                                                    <div className="kt-widget4">
                                                        <div className="kt-widget4__item padding-tb5">
                                                            <table id="tblGreenFee" className="table table-bordered" style={{ width: '100%', backgroundColor: 'none' }}>
                                                                <thead>
                                                                    <tr>
                                                                        <th style={{ width: '5%' }}>No</th>
                                                                        <th style={{ width: '15%' }}>Particular</th>
                                                                        <th style={{ width: '5%' }}>Holes</th>
                                                                        <th style={{ width: '10%' }}>Days</th>
                                                                        <th style={{ width: '10%' }}>Green Fee</th>
                                                                        <th style={{ width: '10%' }}>Cart</th>
                                                                        <th style={{ width: '10%' }}>Caddy</th>
                                                                        <th style={{ width: '10%' }}>Tax</th>
                                                                        <th style={{ width: '10%' }}>Total</th>
                                                                        <th style={{ width: '15%' }}>Remarks</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {rateMasterList.length > 0 && rateMasterList.map((detail, index) => (
                                                                        <tr key={index}>
                                                                            <td>{index + 1}</td>
                                                                            <td>{detail.UserType}</td>
                                                                            <td>{detail.Hole}</td>
                                                                            <td>{detail.Type}</td>
                                                                            <td>
                                                                                <input
                                                                                    type="number"
                                                                                    className="form-control input-sm"
                                                                                    value={detail.GreenFee || 0}
                                                                                    onChange={(e) => updateRateMaster(detail.UserType, detail.Hole, detail.Type, 'GreenFee', e.target.value)}
                                                                                />
                                                                            </td>
                                                                            <td>
                                                                                <input
                                                                                    type="number"
                                                                                    className="form-control input-sm"
                                                                                    value={detail.Cart || 0}
                                                                                    onChange={(e) => updateRateMaster(detail.UserType, detail.Hole, detail.Type, 'Cart', e.target.value)}
                                                                                />
                                                                            </td>
                                                                            <td>
                                                                                <input
                                                                                    type="number"
                                                                                    className="form-control input-sm"
                                                                                    value={detail.Caddy || 0}
                                                                                    onChange={(e) => updateRateMaster(detail.UserType, detail.Hole, detail.Type, 'Caddy', e.target.value)}
                                                                                />
                                                                            </td>
                                                                            <td>
                                                                                <input
                                                                                    type="number"
                                                                                    className="form-control input-sm"
                                                                                    value={detail.Tax || 0}
                                                                                    disabled
                                                                                />
                                                                            </td>
                                                                            <td>
                                                                                <input
                                                                                    type="number"
                                                                                    className="form-control input-sm"
                                                                                    value={Math.round(detail.Total) || 0}
                                                                                    disabled
                                                                                />
                                                                            </td>
                                                                            <td>
                                                                                <textarea
                                                                                    className="form-control input-sm"
                                                                                    style={{ width: '100%', height: '40px' }}
                                                                                    rows="3"
                                                                                    value={detail.Remark || ''}
                                                                                    onChange={(e) => updateRateMaster(detail.UserType, detail.Hole, detail.Type, 'Remark', e.target.value)}
                                                                                ></textarea>
                                                                            </td>
                                                                        </tr>
                                                                    ))}
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-sm-12">
                                                            <div className="clearfix form-actions">
                                                                <button type="button" id="btnSave" name="btnSave" className="btn btn-primary" onClick={handleSave}>
                                                                    <i className="fa fa-save"></i> Save
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            {/* </div> */}
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
            </div>
        </>
    );
};

export default GreenFeeMaster;
